// eslint-disable-next-line import/prefer-default-export
export const SiteReadyState = {
  Unknown: 'Unknown',
  GettingState: 'GettingState',
  Ready: 'Ready',
  NoClients: 'NoClients',
  Down: 'Down',
  Unlicensed: 'Unlicensed'
};

export const AuthMode = {
  Manual: 'Manual',
  SSO: 'SSO',
  Both: 'Both'
};

export const AuthState = {
  Unknown: 'Unknown',
  Requesting: 'Requesting',
  Known: 'Known',
  Unauthorised: 'Unauthorised',
  LoggedOut: 'LoggedOut'
};
